import { NgModule, ModuleWithProviders } from "@angular/core";
import { FormRootDirective } from "./form/form-root.directive";
import { DynamicFormsLiteService } from "./form/dynamic-forms-lite.service";
import {
  DynamicFormType,
  DEFAULT_FORM_COMPONENTS,
  DEFAULT_SUB_TYPE,
  FormComponentsByType
} from "./form-field/form-field-type";
import { ArrayComponent } from "./form-field/array/array.component";
import { GroupComponent } from "./form-field/group/group.component";
import { ReactiveFormsModule } from "@angular/forms";
import { SingleInputComponent } from "./form-field/single/single-input.component";

const DEFAULT_COMPONENTS: FormComponentsByType = new Map();
DEFAULT_COMPONENTS.set(DynamicFormType.SINGLE, { [DEFAULT_SUB_TYPE]: SingleInputComponent });
DEFAULT_COMPONENTS.set(DynamicFormType.GROUP, { [DEFAULT_SUB_TYPE]: GroupComponent });
DEFAULT_COMPONENTS.set(DynamicFormType.ARRAY, { [DEFAULT_SUB_TYPE]: ArrayComponent });

/**
 * The dynamic forms module lets you describe your forms in code.
 */
@NgModule({
  declarations: [FormRootDirective],
  providers: [DynamicFormsLiteService],
  imports: [ReactiveFormsModule],
  exports: [FormRootDirective]
})
export class DynamicFormsLiteModule {
  /**
   * Enables the use of default form components.
   */
  static withDefaultComponents(
    defaultComponents: FormComponentsByType = new Map()
  ): (ModuleWithProviders<DynamicFormsLiteModule> | DynamicFormsLiteComponentsModule)[] {
    return [
      {
        ngModule: DynamicFormsLiteModule,
        providers: [
          {
            provide: DEFAULT_FORM_COMPONENTS,
            useValue: DynamicFormsLiteModule.mergeDefaultComponents(defaultComponents)
          }
        ]
      },
      DynamicFormsLiteComponentsModule
    ];
  }

  private static mergeDefaultComponents(defaultComponents: FormComponentsByType): FormComponentsByType {
    const result = new Map(DEFAULT_COMPONENTS);
    for (let [type, components] of defaultComponents) {
      result.set(type, {
        ...result.get(type),
        ...(components || {})
      });
    }

    return result;
  }
}

@NgModule({
  declarations: [SingleInputComponent, ArrayComponent, GroupComponent],
  entryComponents: [SingleInputComponent, ArrayComponent, GroupComponent],
  imports: [DynamicFormsLiteModule, ReactiveFormsModule]
})
export class DynamicFormsLiteComponentsModule {}
